
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT!
export const version = {
    "dirty": false,
    "raw": "f5eb5f33",
    "hash": "f5eb5f33",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "f5eb5f33",
    "semverString": null,
    "version": "2.1.0",
    "time": "2026-09-17T08:51:53.665Z"
};



// WEBPACK FOOTER //
// ./src/environments/version.ts